export const Page404 = () => {
  return (
    <div id="page-404">
      <div className="fof">
        <h1>Error 404</h1>
      </div>
    </div>
  );
};
